let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gmwfN")).then(() => parcelRequire('53kS0'));